import { useIsMutating, useMutation } from "@tanstack/react-query";
import { rejectBookingApproval } from "PFApp/booking/services/api";
import { useGrowl } from "PFApp/use_growl";
import { useTranslation } from "react-i18next";

import { bookingApprovalsKeys } from "./query_keys";
import { useBookingApprovalsInvalidate } from "./use_booking_approvals_invalidate";

export const useBookingApprovalReject = (...ids: number[]) => {
  const growl = useGrowl();
  const { t } = useTranslation("bookingModule");

  const mutationKey = bookingApprovalsKeys.reject(...ids);

  const { invalidate } = useBookingApprovalsInvalidate();

  const rejectMutation = useMutation(
    async (body: { note?: string | null }) =>
      Promise.all(ids.map((id) => rejectBookingApproval(id, body)))
        .then(() => {
          invalidate();
          growl({
            message: t("approvals.api.reject.success"),
            kind: "success"
          });
        })
        .catch(() => {
          growl({
            message: t("approvals.api.reject.error"),
            kind: "error"
          });
        }),
    {
      mutationKey
    }
  );

  const isMutating = useIsMutating({ mutationKey });

  return {
    mutation: rejectMutation,
    reject: rejectMutation.mutateAsync,
    isMutating
  };
};
